import _ from 'lodash'
import update from 'immutability-helper'
import { handleActions } from 'redux-actions'
import {
    fetchProject,
    fetchProjects,
    loginUser,
    setSearchTerm,
    fetchLanguages,
    updateProject,
    fetchUsers, 
    fetchProjectSuppliers, 
    createNewProject, 
    validateToken, 
    createNewEdition, 
    removeUser, 
    updateUser,
    createNewUser,
    updateLanguage,
    createNewLanguage,
    removeLanguage
} from './actions'
import { setItem } from '../utils/localStorage'

const userReducer = (state, action) => {
    const user = action.payload.user
    return update(state, {
        users: {
            $merge: _.keyBy([user], 'id')
        }
    })
}

const languageRecucer = (state, action) => {
    const language = action.payload.language
    return update(state, {
        languages: {
            $merge: _.keyBy([language], 'id')
        }
    })
}

export default handleActions({
    [fetchProjects]: (state, action) => {
        const projects = _.keyBy(action.payload.projects, 'id')
        return update(state, {
            projects: {
                $set: projects
            }
        })
    },
    [fetchProject]: (state, action) => {
        return update(state, {
            currentProject: {
                $set: action.payload.project
            }
        })
    },
    [fetchProjectSuppliers]: (state, action) => {
        return update(state, {
            currentProjectSuppliers: {
                $set: action.payload.projectSuppliers
            }
        })
    },
    [updateProject]: (state, action) => {
        return update(state, {
            currentProject: {
                $set: action.payload.project
            },
            currentProjectSuppliers: {
                $set: action.payload.projectSuppliers
            }
        })
    },
    [createNewProject]: (state) => {
        return update(state, {
            currentProject: {
                $set: {}
            },
            currentProjectSuppliers: {
                $set: []
            }
        })
    },
    [createNewEdition]: (state, action) => {
        return update(state, {
            projects: {
                $merge: {[action.payload.project.id]: action.payload.project}
            },
            currentProject: {
                $set: action.payload.project
            },
            currentProjectSuppliers: {
                $set: []
            }
        })
    },
    [fetchLanguages]: (state, action) => {
        const languages = _.keyBy(action.payload.languages, 'id')
        return update(state, {
            languages: {
                $set: languages
            }
        })
    },
    [updateLanguage]: languageRecucer,
    [createNewLanguage]: languageRecucer,
    [removeLanguage]: (state, action) => {
        try {
            const language = action.payload.language
            return update(state, {
                languages: {
                    $set: _.pickBy(state.languages, (value, key) => key !== language.id.toString())
                }
            })
        } catch (e) {
            return state
        }
    },
    [fetchUsers]: (state, action) => {
        const users = _.keyBy(action.payload.users, 'id')
        return update(state, {
            users: {
                $set: users
            }
        })
    },
    [updateUser]: userReducer,
    [createNewUser]: userReducer,
    [removeUser]: (state, action) => {
        try {
            const user = action.payload.user
            return update(state, {
                users: {
                    $set: _.pickBy(state.users, (value, key) => key !== user.id.toString())
                }
            })
        } catch (e) {
            return state
        }
    },
    [setSearchTerm]: (state, action) => {
        return update(state, {
            searchTerm: {
                $set: action.payload.searchTerm
            }
        })
    },
    [validateToken]: (state, action) => {
        const { user, token } = action.payload
        if (token !== undefined) {
            setItem('token', token)
        }
        return update(state, {
            user: {
                $set: user !== undefined ? user : false
            }
        })
    },
    [loginUser]: (state, action) => {
        const { user, token } = action.payload
        if (token !== undefined) {
            setItem('token', token)
        }
        return update(state, {
            user: {
                $set: user !== undefined ? user : false
            }
        })
    }
}, {
    user: false,
    searchTerm: '',
    projects: {},
    currentProject: {},
    currentProjectSuppliers: {},
    users: {},
    languages: {}
})



// WEBPACK FOOTER //
// ./src/store/reducer.js